// components/ContactInfo.jsx
import React from "react";
import FormInput from "./FormInput";
import { useSelector } from "react-redux";

const ContactInfo = ({ formData, onChange }) => {
  const { name, email, mobile, message } = formData;

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-text">Contact</h2>
      <FormInput
        label="Name"
        value={name}
        onChange={(e) => onChange("name", e.target.value)}
      />
      <FormInput
        label="Email"
        type="email"
        value={email}
        onChange={(e) => onChange("email", e.target.value)}
      />
      <FormInput
        label="Mobile"
        type="tel"
        value={mobile}
        onChange={(e) => onChange("mobile", e.target.value)}
      />
      <FormInput
        label="Message"
        value={message}
        onChange={(e) => onChange("message", e.target.value)}
      />
    </div>
  );
};

export default ContactInfo;
